//推荐房产管理
export default [{
  path: '/sortManage',
  component: () => import('../pages/houseRecommendManage/sortManage.vue'),
  name: 'SortManage',
  title: "分类管理",
  meta: {
    title: "分类管理"
  }
},
  {
    path: '/houseInfoManage',
    component: () => import('../pages/houseRecommendManage/houseInfoManage.vue'),
    name: 'HouseInfoManage',
    title: "房产信息管理",
    meta: {
      title: "房产信息管理",
    }
  }, {
    path: '/orderManage',
    component: () => import('../pages/houseRecommendManage/orderManage.vue'),
    name: 'OrderManage',
    title: "预约管理",
    meta: {
      title: "预约管理"
    }
  }, {
    path: '/addHouseInfoManage',
    component: () => import('../pages/houseRecommendManage/addHouseInfoManage.vue'),
    name: 'AddHouseInfoManage',
    title: "编辑房产信息管理",
    meta: {
      title: "编辑房产信息管理"
    }
  }, {
    path: '/houseInfo',
    component: () => import('../pages/houseRecommendManage/houseInfo.vue'),
    name: 'HouseInfo',
    title: "房产详情",
    meta: {
      title: "房产详情"
    }
  },
  {
    path: '/orderInfo',
    component: () => import('../pages/houseRecommendManage/orderInfo.vue'),
    name: 'OrderInfo',
    title: "预约详情",
    meta: {
      title: "预约详情"
    }
  },
  {
    path: '/extractRecord',
    component: () => import('../pages/houseRecommendManage/extractRecord.vue'),
    name: 'ExtractRecord',
    title: "佣金提现记录",
    meta: {
      title: "佣金提现记录"
    }
  },
];
